import { Section } from "react-scroll-section"
import "../style/css/Featured.css"

const Featured = () => {
    return (
        <Section id="featured" style={{ width: "100%" }}>
            <div className="container f-container">
                <div className="video-wrapper">
                    <iframe
                        width="560"
                        height="315"
                        className="video"
                        src="https://www.youtube.com/embed/YNdbMvzz0xM?si=8AO2LaI_4ARyP0H8"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture, web-share"
                        allowFullScreen>
                    </iframe>
                </div>


            </div>
        </Section>
    )
}
export default Featured